import { Address } from '~domains/partner-application/entities/application';

import { ReviewItem } from './review-item';

export const AddressReviewItems = ({ address }: { address: Address }) => {
  return (
    <>
      <ReviewItem title="Province" value={address.province} />
      <ReviewItem
        title="City/Municipality"
        value={address.cityOrMunicipality}
      />
      <ReviewItem title="ZIP Code" value={address.postalCode} />
      <ReviewItem title="Barangay" value={address.barangay} />
      <ReviewItem
        title="House number, Street name"
        value={address.streetAndHouse}
      />
      <ReviewItem
        title="Unit/Apartment (if any)"
        value={address.unitAndFloor}
        hideIfEmpty
      />
    </>
  );
};
